import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux'

// Components
import AjaxController from '../system/ajaxController';

// Redux slices
import { setActivePage, setUser, setToken } from '../../appSlice';
import { updateObjectData } from './objectSlice';

// SemanticUI components
import { Table, TableHeader, TableRow, TableHeaderCell, TableBody, TableCell, Popup, Button, Menu, MenuItem, Form, FormInput, FormGroup, FormField, Input, FormCheckbox, Segment, Header, FormSelect, Icon, HeaderSubheader, Grid, List, ListItem, ListIcon, ListHeader, ListDescription, ListContent } from 'semantic-ui-react'


/* Snackbar
 * https://notistack.com/api-reference
 */
import { useSnackbar } from 'notistack';


/*
 * https://date-fns.org/v4.1.0/docs/addDays
 * https://www.npmjs.com/package/react-datepicker
 * https://reactdatepicker.com/#example-locale-without-global-variables
 */
import DatePicker from "react-datepicker";
import { registerLocale, setDefaultLocale } from  "react-datepicker";
import { eachMonthOfInterval, format, isWithinInterval, parseISO } from 'date-fns'
import { de } from 'date-fns/locale/de';

// Styles
import './object.css';



registerLocale('de', de);
setDefaultLocale('de');



/**
 * 
 * @param {string} datumString 
 * @returns {bool}
 */
const isWeekend = (datumString) => {
  const datum = new Date(datumString);
  const wochentag = datum.getDay();

  // Überprüfen, ob der Wochentag Samstag (6) oder Sonntag (0) ist
  return wochentag === 0 || wochentag === 6;
}



/**
 * 
 * @param {string} startDate 
 * @param {string} endDate 
 * @returns {object}
 */
const getMonthsBetweenDates = (startDate, endDate) => {
  // Erstellen der Liste von Monaten im angegebenen Bereich
  const months = eachMonthOfInterval({ start: new Date(startDate), end: new Date(endDate) });

  // Umwandlung in das gewünschte Format
  return months.map((date) => {
    return {
      num: parseInt(format(date, 'M', { locale: de })),
      year: parseInt(format(date, 'yyyy', { locale: de })),
      name: format(date, 'MMMM', { locale: de })
    };
  });
}



/**
 * 
 * @returns 
 */
const Max2AllotmentsMonthGrid = ({roomCode, roomDates, metaData, isEditMode, manipulations, setManipulations}) => {
  
  //
  const days = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31];
  const months = getMonthsBetweenDates(metaData?.Period?.Start, metaData?.Period?.End);



  /**
   * {Start: null, End: null, Rooms: [], StopSale: false, OnRequest: false, Manipulation: ''}
   * @param {event} e 
   */
  const handleDayFieldChange = (e, dateStr) => {
    if (e.target.value === 'S' || e.target.value === 's' || e.target.value === '0') {
        setManipulations([...manipulations, {Start: dateStr, End: null, Rooms: [roomCode], StopSale: true, OnRequest: false, Manipulation: ''}]);
      } else {
        if (e.target.value === 'R' || e.target.value === 'r') {
          setManipulations([...manipulations, {Start: dateStr, End: null, Rooms: [roomCode], StopSale: false, OnRequest: true, Manipulation: ''}]);
        } else {
          setManipulations([...manipulations, {Start: dateStr, End: null, Rooms: [roomCode], StopSale: false, OnRequest: false, Manipulation: e.target.value}]);
        }
      }
  }


  // Header row
  const headerDays = days.map((day) => {
    return <TableHeaderCell key={day}>{day}</TableHeaderCell>
  });
  
  // all month rows
  const monthRows = months.map((month) => {
    const rowKey    = 'row-' + month
    const rowKey2   = 'row-' + month + '-booked';
    
    // all days
    const dayCellsAllotments = days.map((day) => {
      const dateStr   = month.year + '-' + (month.num < 10 ? '0' : '') + month.num + '-' + (day < 10 ? '0' : '') + day;
      const todayStr  = new Date().toISOString().split('T')[0];
      const cellKey   = month.num + '-' + day;
      const fdateTTip = format(new Date(dateStr), 'cccc, dd.MM.yyyy', { locale: de }) 
      let allotment = roomDates[dateStr]?.Allotment;
      let status    = roomDates[dateStr]?.Status;

      // apply manipulations
      manipulations.forEach(manipulation => {
        const datum = parseISO(dateStr); // Das zu prüfende Datum
        const startDatum = parseISO(manipulation.Start); // Start der Spanne
        const endDatum = parseISO(manipulation.End ? manipulation.End : manipulation.Start); // Ende der Spanne
        const liegtInnerhalb = isWithinInterval(datum, { start: startDatum, end: endDatum });
        const isRoom = !manipulation.Rooms || !manipulation.Rooms.length || manipulation.Rooms.includes(roomCode) ? true : false; 
        if (liegtInnerhalb && isRoom) {
          if (manipulation.StopSale || manipulation.Manipulation === '0') {
            status = 'StopSale';
          } else {
            if (manipulation.OnRequest) {
              status = 'onRequest';
            } else {
              status = '';
              if (/^\+/.test(manipulation.Manipulation)) {
                const val = parseInt(manipulation.Manipulation.replace('+', ''))
                allotment = parseInt(allotment) + val;
              } else if (/^-/.test(manipulation.Manipulation)) {
                const val = parseInt(manipulation.Manipulation.replace('-', ''))
                allotment = parseInt(allotment) - val;
                allotment = allotment < 0 ? 0 : allotment;
              } else if (/^\d/.test(manipulation.Manipulation)) {
                allotment = parseInt(manipulation.Manipulation)
              }
            }
          }
        }
      });

      //
      if (typeof roomDates[dateStr] !== 'undefined' && dateStr.replace('-', '').replace('-', '') >= todayStr.replace('-', '').replace('-', '')) {
        if (status === 'StopSale') {
          const className = 'allotments_day_td first_row stopsale' + (isWeekend(dateStr) ? ' weekend' : '');
          const trigger = isEditMode 
            ? <input className="allotments_day_input" type="text" value={allotment} maxLength="3" size={3} onChange={(e) => handleDayFieldChange(e, dateStr)} style={{borderRadius: '0px !important' }} /> 
            : <span>{allotment}</span>;
          return (
            <TableCell key={cellKey} textAlign='center' className={className}>
              <Popup content={fdateTTip} trigger={trigger} />
            </TableCell>
          )
        } else {
          if (status === 'onRequest') {
            const className = 'allotments_day_td first_row onrequest' + (isWeekend(dateStr) ? ' weekend' : '');
            const trigger = isEditMode 
            ? <input className="allotments_day_input" type="text" value={allotment} maxLength="3" size={3} onChange={(e) => handleDayFieldChange(e, dateStr)} style={{borderRadius: '0px !important' }} />
            : <span>{allotment}</span>;
            return (
              <TableCell key={cellKey} textAlign='center' className={className}>
                <Popup content={fdateTTip} trigger={trigger} />
              </TableCell>
            )
          } else {
            const className = 'allotments_day_td first_row available' + (isWeekend(dateStr) ? ' weekend' : '');
            const trigger = isEditMode 
            ? <input className="allotments_day_input" type="text" value={allotment} maxLength="3" size={3} onChange={(e) => handleDayFieldChange(e, dateStr)} style={{borderRadius: '0px !important' }} />
            : <span>{allotment}</span>;
            return ( 
              <TableCell key={cellKey} textAlign='center' className={className}>
                <Popup content={fdateTTip} trigger={trigger} />
              </TableCell>
            )
          }
        }
      } else {
        return <TableCell key={cellKey} className='allotments_day_td first_row'></TableCell>
      }
    });

    
    const dayCellsBooked = days.map((day) => {
      const dateStr  = month.year + '-' + (month.num < 10 ? '0' : '') + month.num + '-' + (day < 10 ? '0' : '') + day;
      const todayStr = new Date().toISOString().split('T')[0];
      const cellKey = month.num + '-' + day + '-booked';

      if (typeof roomDates[dateStr] !== 'undefined' && dateStr.replace('-', '').replace('-', '') >= todayStr.replace('-', '').replace('-', '')) {
        const className = 'allotments_day_td booked' + (isWeekend(dateStr) ? ' weekend' : '');
        return <TableCell key={cellKey} textAlign='center' className={className}>{roomDates[dateStr]?.Booked}</TableCell>
      } else {
        const className = 'allotments_day_td';
        return <TableCell key={cellKey} textAlign='center' className={className}></TableCell>
      }
    });
    

    return (
      <>
      <TableRow key={rowKey}>
        <TableCell className='calender first_row' rowSpan={2} style={{borderRight: "1px solid rgba(34, 36, 38, .1)"}}>{month.name}<br/>{month.year}</TableCell>
        {dayCellsAllotments}
      </TableRow>
      <TableRow key={rowKey2}>
        {dayCellsBooked}
      </TableRow>
      </>
    );
  });
  /**/


  
  return (
    <>
      <Table celled collapsing>
        <TableHeader>
          <TableRow>
            <TableHeaderCell className='calender' colSpan={32}>{roomCode} - Doppelzimmer zur Alleinbenutzung</TableHeaderCell>
          </TableRow>
          <TableRow>
            <TableHeaderCell className='calender'>Monat/Jahr</TableHeaderCell>
            {headerDays}
          </TableRow>
        </TableHeader>
        <TableBody>
          {monthRows}
        </TableBody>
      </Table>
    
      <Table basic='very' celled collapsing>
        <TableBody>
          <TableRow>
            <TableCell className='allotments_day_td'><span style={{marginRight: '25px'}}>Legende:</span></TableCell>

            <TableCell className='allotments_day_td available'><span style={{marginRight: '20px'}}>&nbsp;</span></TableCell>
            <TableCell className='allotments_day_td available weekend'><span style={{marginRight: '20px'}}>&nbsp;</span></TableCell>
            <TableCell className='allotments_day_td'><span style={{paddingLeft: '5px', marginRight: '25px'}}>verfügbar</span></TableCell>

            <TableCell className='allotments_day_td onrequest'><span style={{marginRight: '20px'}}>&nbsp;</span></TableCell>
            <TableCell className='allotments_day_td onrequest weekend'><span style={{marginRight: '20px'}}>&nbsp;</span></TableCell>
            <TableCell className='allotments_day_td'><span style={{paddingLeft: '5px', marginRight: '25px'}}>OnRequest</span></TableCell>

            <TableCell className='allotments_day_td stopsale'><span style={{marginRight: '20px'}}>&nbsp;</span></TableCell>
            <TableCell className='allotments_day_td stopsale weekend'><span style={{marginRight: '20px'}}>&nbsp;</span></TableCell>
            <TableCell className='allotments_day_td'><span style={{paddingLeft: '5px', marginRight: '25px'}}>StopSale</span></TableCell>

            <TableCell className='allotments_day_td booked'><span style={{marginRight: '20px'}}>&nbsp;</span></TableCell>
            <TableCell className='allotments_day_td booked weekend'><span style={{marginRight: '20px'}}>&nbsp;</span></TableCell>
            <TableCell className='allotments_day_td'><span style={{paddingLeft: '5px', marginRight: '25px'}}>gebucht</span></TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </>
  )
}



/**
 * 
 * @returns 
 */
const Max2Allotments = (params) => {
  let manipulationTemplate = {Start: null, End: null, Rooms: [], StopSale: false, OnRequest: false, Manipulation: ''};

  // lokal State
  const [activeItem, setActiveItem]                   = useState(false);
  const [manipulations, setManipulations]             = useState([]);
  const [currentManipulation, setCurrentManipulation] = useState({...manipulationTemplate});
  
  // global State
  const dispatch    = useDispatch();
  const object      = useSelector((state) => state.object.data);
  const isEditMode  = useSelector((state) => state.object.sections.Allotments.edit);
  const backendUrl  = useSelector((state) => state.app.backend.baseProtocol) + '://' + useSelector((state) => state.app.backend.url);

  // Snackbar
  const { enqueueSnackbar } = useSnackbar();

  // current allotments (main or sub)
  const currentAllotments = params.isSubAllotment === true ? object?.SubAllotments[params.subCode] : object?.Allotments; 



  /**
   * 
   * @param {string} name 
   */
  const handleItemClick = (name) => {
    setActiveItem(name);
  }
  


  /**
   * 
   * @param {event} e 
   */
  const handleManipulationInput = (e) => {
    const str = currentManipulation.Manipulation + e.key;
    if (/^[+-]?\d+(\.\d+)?$/.test(str) || /^[SsRr]$/.test(str) || /^[+-]$/.test(str)) {
      // do nothing
    } else {
      e.preventDefault();
    }
  };



  /**
   * 
   * @param {int indexToDelete 
   */
  const handleDeleteManipulation = (indexToDelete) => {
    setManipulations(manipulations.filter((_, index) => index !== indexToDelete));
  }



  /**
   * 
   * @param {int} delay 
   */
  const handleSendManipulations = async (delay) => {

    // Controller for AJAX requests
    const api = new AjaxController(backendUrl, () => {
      dispatch(setActivePage('START'));
      dispatch(setUser(null));
      dispatch(setToken(null));
    });

    try {
      const data = {
        Code: params.isSubAllotment === true ? params.subCode : object?.Product?.Code,
        Delay: delay,
        Manipulations: manipulations,
        AllRooms: currentAllotments?.Meta?.Rooms,
        Source: currentAllotments?.Dates,
        Period: currentAllotments?.Meta?.Period,
      }
      let response = await api.put('/allotments/send', data);

      if (response.status === 'success') {
        enqueueSnackbar('Manipulationen erfolgreich gesendet', { variant: 'success' });

        if (typeof response.messages !== 'undefined') {
          response.messages.forEach(message => {
            enqueueSnackbar(message.content, { variant: 'info' });
          });
        }

        // Manipulationen zurücksetzen
        setManipulations([]);
        setCurrentManipulation({...manipulationTemplate});

        // Allotments neuladen
        dispatch(updateObjectData({section: 'Allotments', value: response.allotments}))
        return;
      }
    } catch (error) {
      enqueueSnackbar('Fehler beim Senden der Manipulationen. Bitte versuchen Sie es später erneut.', { variant: 'error' });
      return;
    }
  }

  

  // show selected room
  const roomMenuItems = currentAllotments?.Meta?.Rooms.map((roomCode, roomIndex) => {
    return <MenuItem key={roomIndex} name={roomCode} active={activeItem === roomCode} onClick={() => handleItemClick(roomCode) } />
  });
  if (!activeItem) {
    setActiveItem(Object.keys(currentAllotments?.Dates)[0])
  }
  const roomDates = currentAllotments?.Dates[activeItem];

  // bild room oprions array for room select
  const roomOptions = currentAllotments?.Meta?.Rooms.map((roomCode, roomKey) => {
    return {key: roomKey, value: roomCode, text: roomCode}
  })

  
  // build manipulation rows
  const manipulationRows = manipulations.map((manipulation, key) => {
    const dateStart   = manipulation.Start ? format(new Date(manipulation.Start), 'dd.MM.yyyy') : ''
    const dateEnd     = manipulation.End && manipulation.End !== manipulation.Start ? format(new Date(manipulation.End), 'dd.MM.yyyy') : '';
    const dateString  = dateStart + (manipulation.End ? ' - ' + dateEnd : '');
    const roomsString = manipulation.Rooms.length ? manipulation.Rooms.join(', ') : 'alle';
    const manipulationString = manipulation.StopSale ? 'StopSale' : ( manipulation.OnRequest ? 'OnRequest' : manipulation.Manipulation);
    return (
      <TableRow negative key={key}>
        <TableCell>{dateString}</TableCell>
        <TableCell>{roomsString}</TableCell>
        <TableCell>{manipulationString}</TableCell>
        <TableCell><Button basic circular icon size='tiny' onClick={()=>handleDeleteManipulation(key)}><Icon name='trash' /></Button></TableCell>
      </TableRow>
    );
  });

  // build pending requests info box
  let pendingRequests = [];
  if (currentAllotments?.Meta?.Messages) {
    currentAllotments?.Meta?.Messages.forEach(message => {
      pendingRequests.push(
        <ListItem>
          <ListIcon name='hourglass outline' size='large' verticalAlign='middle' />
          <ListContent>
            <ListHeader>{message.content}</ListHeader>
            <ListDescription>{message.meta}</ListDescription>
          </ListContent>
        </ListItem>
      );
    });
    
  }

  
  return (
    <>
    <br />
    {params.isMainAllotment === true ? <Header as='h2'>Allotments Hauptkontingent</Header> : <></>}
    {params.isSubAllotment === true ? <Header as='h2'>Allotments Teilkontingent<HeaderSubheader>{params.subCode}</HeaderSubheader></Header> : <></>}
    <br />
    {pendingRequests && pendingRequests.length 
      ? (
        <Segment style={{backgroundColor: '#fee'}}>
          <List relaxed>
              {pendingRequests}
          </List>
        </Segment>
        )
      : <></>
    }
    {isEditMode && (
      <Segment style={{backgroundColor: '#eee'}}>
        <Header as='h4'>Kontingente ändern</Header>
        <Form>
            <FormGroup inline>
              <DatePicker
                showWeekNumbers
                selectsStart
                label       = 'von'
                selected    = {currentManipulation.Start}
                startDate   = {currentManipulation.Start}
                endDate     = {currentManipulation.End}
                dateFormat  = "ddMMyy"
                placeholder = 'TTMMJJ'
                onChange    = {(date) => setCurrentManipulation({...currentManipulation, Start: format(date, "yyyy-MM-dd")})}
                customInput = {<FormInput inline icon='calendar alternate' iconPosition='left' label="von" placeholder='TTMMJJ' style={{width: "130px"}} />}
                />
              <FormField><span>&nbsp;</span></FormField>

              <DatePicker
                showWeekNumbers
                selectsEnd
                label       = 'bis'
                selected    = {currentManipulation.End}
                startDate   = {currentManipulation.Start}
                endDate     = {currentManipulation.End}
                minDate     = {currentManipulation.Start}
                dateFormat  = "ddMMyy"
                placeholder = 'TTMMJJ'
                onChange    = {(date) => setCurrentManipulation({...currentManipulation, End: format(date, "yyyy-MM-dd")})}
                customInput = {<FormInput inline icon='calendar alternate' iconPosition='left' label="bis" placeholder='TTMMJJ' style={{width: "130px"}} />}
              />
              <FormField><span>&nbsp;</span></FormField>

              <FormField inline>
                <label>Zimmer<sup>*</sup></label>
              </FormField>
              <FormSelect 
                multiple 
                options   = {roomOptions} 
                value     = {currentManipulation.Rooms} 
                onChange  = {(e, data) => setCurrentManipulation({...currentManipulation, Rooms: data.value})} 
              />
              <FormField><span>&nbsp;</span></FormField>

              <FormField inline>
                <label>StopSale</label>
              </FormField>
              <FormCheckbox 
                toggle 
                checked = {currentManipulation.StopSale} 
                onClick = {() => setCurrentManipulation({...currentManipulation, StopSale: !currentManipulation.StopSale})} 
              />
              <FormField><span>&nbsp;</span></FormField>

              <FormField inline>
                <label>Änderung</label>
                <Input 
                  placeholder = '5, +5, -5, S, R' 
                  disabled    = {currentManipulation.StopSale} 
                  value       = {currentManipulation.Manipulation}
                  onKeyPress  = {handleManipulationInput}
                  onChange    = {(e) => {
                    if (e.target.value === 'S' || e.target.value === 's' || e.target.value === '0') {
                      setCurrentManipulation({...currentManipulation, StopSale: true, Manipulation: ''});
                    } else {
                      if (e.target.value === 'R' || e.target.value === 'r') {
                        setCurrentManipulation({...currentManipulation, OnRequest: true, Manipulation: ''});
                      } else {
                        setCurrentManipulation({...currentManipulation, Manipulation: e.target.value});
                      }
                    }
                  }}
                />
              </FormField>
              <Button circular basic icon title="Manipulation hinzufügen" onClick={() => { setManipulations([...manipulations, currentManipulation]); setCurrentManipulation({...manipulationTemplate, Manipulation: ''})}} ><Icon name='add' /></Button>
          </FormGroup>
        </Form>
        <span style={{color: '#aaa'}}><sup>*</sup>&nbsp;Wenn keine Zimmer ausgewählt werden, wird die Manipulation auf alle Zimmer angewendet</span>


        {manipulations.length > 0 && (
          <>
          <Header as='h4'>
            Schwebende Änderungen
            <HeaderSubheader style={{color:'red'}}><Icon name='warning sign' />Änderungen werden erst durch Klick auf einen der nebenstehenden Buttons gespeichert!</HeaderSubheader>
          </Header>
          <Grid columns={2}>
            <Grid.Column>
              <Table basic>
                <TableHeader>
                  <TableRow negative>
                    <TableHeaderCell>Datum</TableHeaderCell>
                    <TableHeaderCell>Zimmer</TableHeaderCell>
                    <TableHeaderCell>Änderung</TableHeaderCell>
                    <TableHeaderCell></TableHeaderCell>
                  </TableRow>
                </TableHeader>
                <TableBody>
                  {manipulationRows}
                </TableBody>
              </Table>
            </Grid.Column>
            <Grid.Column>
              <Button primary circular icon="save"            labelPosition='left' style={{margin: '5px'}} onClick={()=>handleSendManipulations(0)} content="Änderungen sofort ausführen" /><br /><br />
              <Button primary circular icon="hourglass half"  labelPosition='left' style={{margin: '5px'}} onClick={()=>handleSendManipulations(4)} content="Änderungen 4h verzögert ausführen" /><br /><br />
              <Button primary circular icon="hourglass end"   labelPosition='left' style={{margin: '5px'}} onClick={()=>handleSendManipulations(8)} content="Änderungen 8h verzögert ausführen" /><br /><br />
            </Grid.Column>
          </Grid>
          </>
        )}
      </Segment>
    )}
    <br />
    <Menu pointing>{roomMenuItems}</Menu>
    <Max2AllotmentsMonthGrid key={activeItem} roomCode={''+activeItem} roomDates={roomDates} metaData={currentAllotments?.Meta} isEditMode={isEditMode} manipulations={manipulations} setManipulations={setManipulations} />
    </>
  )
}

export default Max2Allotments;